import { CognitoPermissionGroups as P } from 'core/helpers/cognito-permission-groups';
import { isContextualToolsPreview } from './preview-context';

// Only passed to the simulated panel. Auth, host pages, and full-page tools keep the real session.
export function getPanelSession(session) {
  if (!isContextualToolsPreview()) {
    return session;
  }
  return {
    ...session,
    [P.canViewOfferOverridesTool]: true,
    [P.canViewPolicyOverridesTool]: true,
    [P.canUpdatePolicyRep]: true,
    [P.canSetMemberAffinity]: true,
    [P.toolsCanTransferInsuranceScores]: true,
    [P.toolAllOverridesAccess]: true,
    contextualToolsSampleAccess: true
  };
}
